var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNegativo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "negativo",
    d: "M77,98A49.013,49.013,0,0,1,57.927,3.851a49.013,49.013,0,0,1,38.146,90.3A48.691,48.691,0,0,1,77,98Zm-.015-39.844h0l9.591,9.588a2.78,2.78,0,0,0,1.991.8,3.722,3.722,0,0,0,2.578-1.112l4.29-4.306a3.267,3.267,0,0,0,.322-4.55l-9.591-9.559,9.591-9.606a2.725,2.725,0,0,0,.786-1.961,3.647,3.647,0,0,0-1.108-2.56l-4.29-4.334a3.824,3.824,0,0,0-2.553-1.1H88.5a2.773,2.773,0,0,0-1.927.773l-9.591,9.6-9.558-9.6a2.765,2.765,0,0,0-1.923-.773h-.088a3.838,3.838,0,0,0-2.556,1.1L58.57,34.889A3.607,3.607,0,0,0,57.456,37.4v.071a2.739,2.739,0,0,0,.8,1.942l9.588,9.606-9.588,9.559a2.767,2.767,0,0,0-.8,1.949v.071a3.7,3.7,0,0,0,1.114,2.531L62.86,67.43a3.738,3.738,0,0,0,2.58,1.112,2.773,2.773,0,0,0,1.987-.8l9.557-9.588Z",
    transform: "translate(-28)",
    fill: "#d1111c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativo);
export default __webpack_public_path__ + "static/media/negativo.f8aca06168d317fb7577eac51cc2062c.svg";
export { ForwardRef as ReactComponent };